'use strict';

function ForgotPassword($http) {
  var vm = this;

  vm.$onInit = $onInit;
  vm.forgotPassword = _forgotPassword;

  function $onInit() {}

  function _forgotPassword() {
    vm.active = true;
    $http.post('/password_reset/', {'email': vm.email}).then(_success).catch(_failed);
  }
  function _success() {
    vm.displaySuccess = true;
    vm.active = false;
  }

  function _failed() {
    vm.active = false;
  }
}

module.exports = ForgotPassword;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/auth/forgot-password/forgot-password.controller.js
 ** module id = 184
 ** module chunks = 0
 **/